import React from 'react';
import { motion } from 'framer-motion';
import './About.css';
import { aboutData } from '../../data/aboutData';
import {
  FaMobileAlt,
  FaProjectDiagram,
  FaGraduationCap,
  FaRocket,
  FaUserTie,
  FaBuilding,
  FaUsers,
  FaChalkboardTeacher
} from 'react-icons/fa';

const iconMap = {
  FaMobileAlt,
  FaProjectDiagram,
  FaGraduationCap,
  FaRocket,
  FaUserTie,
  FaBuilding,
  FaUsers,
  FaChalkboardTeacher
};

const About = () => {
  const getIconComponent = (iconName) => iconMap[iconName] || FaMobileAlt;

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.15 }
    }
  };

  const cardItem = {
    hidden: { opacity: 0, y: 44 },
    show: {
      opacity: 1,
      y: 0,
      transition: { type: 'spring', stiffness: 260, damping: 22 }
    }
  };

  const spring = { type: 'spring', stiffness: 320, damping: 22 };

  return (
    <section id={aboutData.header.id} className="about-section">
      <motion.h5
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        {aboutData.header.subtitle}
      </motion.h5>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.08 }}
      >
        {aboutData.header.title}
      </motion.h2>

      <div className="container containerAbout">
        <motion.div
          className="aboutContent"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-40px' }}
        >
          <div className="cards">
            {aboutData.cards.map((card, index) => {
              const IconComponent = getIconComponent(card.icon);
              return (
                <motion.div
                  key={index}
                  className="about-card"
                  variants={cardItem}
                  whileHover={{
                    y: -12,
                    scale: 1.03,
                    transition: spring
                  }}
                  whileTap={{ scale: 0.98 }}
                >
                  <motion.div
                    className="about-card-icon"
                    whileHover={{ rotate: [0, -10, 10, 0], transition: { duration: 0.5 } }}
                  >
                    <IconComponent />
                  </motion.div>
                  <h5>{card.title}</h5>
                  <h6>{card.subtitle}</h6>
                </motion.div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
